import { webportalUrl, currentTheme, apiUrls } from '@/../appConfig';
import { WebPortal } from '@/models/WebPortal';
import { defineStore } from 'pinia'
import { config } from '@/api/config';
import axios from 'axios';

//Import required pinia stores
import { useLaundryStore } from './laundry';

import locale from '@/localeConfig';

export function buildVlApiUrl(baseUrl: string): string {
    const normalized = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    return normalized + '1.0/' + locale.locale;
}

export const useWebportalStore = defineStore('webportal', {
    state: () => ({
        webportals: [] as WebPortal[],
        selectedWebportal: (JSON.parse(localStorage.getItem('webportal') || '{}') ?? null) as WebPortal,
        authenticatedApiUrl: localStorage.getItem('authenticatedApiUrl') as string | null,
        version: localStorage.getItem('version'),
        vlApiVersion: localStorage.getItem('vlApiVersion'),
        lockWebportal: false
    }),
    actions: {
        async getWebPortals() {
            //Reset webportals
            this.webportals = [];
            
            if (webportalUrl) {
                this.selectedWebportal = {
                    "Naam": currentTheme as string,
                    "ServiceUrl": webportalUrl,
                    "API": apiUrls
                } as WebPortal
                this.webportals.unshift(this.selectedWebportal)
                localStorage.setItem('webportal', JSON.stringify(this.selectedWebportal));
                return
            }

            //Get webportals from webportalCentraal
            try {
                const response = await axios.post(`${config.webportalCentraalURL}/GetWebportals`, { appID: 2 });
                // eslint-disable-next-line
                this.webportals = response.data.d.map(({ __type, ...rest }: { __type: string }) => rest)
                // this.webportals = response.data.d.map(({ __type, ...rest }: { __type: string }) => rest).map((p: any) => {
                //     const match = p.ServiceUrl?.match(/(?:https:\/\/)(.*)\.(?:.*)\.net/)
                //     if (match?.length && match.length > 1) {
                //         p.ServiceUrl = p.ServiceUrl.replace(match[1], match[1] + 'sim')
                //     }
                //     return p
                // });
            } catch (error: any) {
                console.error(error);
            } finally {
                //add debug portal to localhosts
                if(process.env.NODE_ENV == 'development'){
                    this.webportals.unshift({ Naam: 'localhost debug', ServiceUrl: config.debugServicesUrl, API: [config.debugVlApiUrl], virtwassWebUrl: config.debugVirtwassWebUrl });
                }

                // refresh currently set webportal
                if (this.selectedWebportal?.Naam) {
                    const webportal = this.webportals.find((w) => w.Naam && w.Naam === this.selectedWebportal.Naam) ?? null
                    if (webportal) {
                        this.selectedWebportal = webportal
                        localStorage.setItem('webportal', JSON.stringify(webportal));
                    }
                }

                const currentWebportal = this.webportals.find(w => w.ServiceUrl?.startsWith(window.location.origin));
                if (currentWebportal) {
                    this.lockWebportal = true;
                    this.setWebPortal(currentWebportal.Naam);
                }
                else {
                    this.lockWebportal = false;
                }
            }
        },

        setWebPortal(name: string) {
            if (webportalUrl) {
                return;
            }
            //Get webportal out of webportals by name
            this.webportals.forEach((portal) => {
                //Set selected portal and add to localStorage as stringified object
                if (portal.Naam === name) {
                    this.selectedWebportal = portal;
                    localStorage.setItem('webportal', JSON.stringify(portal));
                }
            })
        },

        setAuthenticatedApiUrl(baseUrl: string) {
            this.authenticatedApiUrl = baseUrl;
            localStorage.setItem('authenticatedApiUrl', baseUrl);
        },

        clearAuthenticatedApiUrl() {
            this.authenticatedApiUrl = null;
            localStorage.removeItem('authenticatedApiUrl');
        }
    },
    getters: {
        vlApiUrl: (state) => {
            if (!state.authenticatedApiUrl) {
                return '';
            }
            return buildVlApiUrl(state.authenticatedApiUrl);
        },
        virtwassUrl: (state) => {
            //For debug
            if(state.selectedWebportal?.virtwassWebUrl){
                return state.selectedWebportal.virtwassWebUrl;
            }

            const laundryStore = useLaundryStore();
            if(laundryStore.currentLaundry.nrWasserij != 37){
                return `https://vl${laundryStore.currentLaundry.nrWasserij}virtwass.virtuallaundry.net/`;
                //return `https://vlsim${laundryStore.currentLaundry.nrWasserij}virtwass.virtuallaundry.net/`;
            }
            else{
                return 'https://vl37tvirtwass.virtuallaundry.net/';
            }
        }
    }
})